import { Component, inject, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MatCell, MatCellDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { IInviteCode, InstanceDetails } from './instance-details.models';
import { HttpClient } from '@angular/common/http';
import { BoolToImgPipe } from '../../_infrastructure/pipes';
import { AsyncPipe, DatePipe } from '@angular/common';
import { MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { env } from '../../../env/env';
import { ClientPreview } from '../../clients/clients.models';
import { MatSlideToggle, MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AddInviteCodeDialog } from './dialogs/add-invite-code-dialog/add-invite-code-dialog';
import { Observable, of } from 'rxjs';
import { RolePermissionDirective } from '../../_infrastructure/directives/role-permission.directive';

@Component({
  selector: 'app-instance-details',
  templateUrl: './instance-details.html',
  styleUrl: './instance-details.css',
  imports: [
    MatTab,
    MatTabGroup,
    MatTableModule,
    MatRow,
    MatHeaderRow,
    MatHeaderCellDef,
    MatHeaderRowDef,
    MatRowDef,
    MatCellDef,
    MatHeaderCellDef,
    MatCell,
    MatHeaderCell,
    BoolToImgPipe,
    DatePipe,
    MatButtonModule,
    MatSlideToggle,
    AsyncPipe,
    RolePermissionDirective
  ],
})

export class InstanceDetailsComponent {
  constructor(private httpClient: HttpClient, private route: ActivatedRoute, private router: Router) {
    this.instanceId = this.route.snapshot.params['id'];
  }

  readonly dialog = inject(MatDialog);
  private instanceId: string;
  public clients: MatTableDataSource<ClientPreview> = new MatTableDataSource<ClientPreview>;
  public instanceDetails$: Observable<InstanceDetails> | null = null;

  ngOnInit() {
    this.loadClients();
    this.loadInstanceDetails();
  }

  private loadClients() {
    this.httpClient.get(`${env.apiUrl}/app-instances/${this.instanceId}/clients`).subscribe({
      next: s => {
        this.clients.data = s as ClientPreview[];
      }
    });
  }

  private tabActions: Record<number, () => void> = {
    0: this.loadClients,
    1: this.loadInviteCodes
  };

  public inviteCodes: MatTableDataSource<IInviteCode> = new MatTableDataSource<IInviteCode>();

  public tabChanged($e: any): void {
    let tabIndex = $e.index as number;
    let action = this.tabActions[tabIndex];
    action.call(this);
  }

  private loadInstanceDetails(): void {
    this.instanceDetails$ =  of({
      id : '1',
      name : 'Test Instance',
      default : true,
      billing : false
    })
  }

  private loadInviteCodes(): void {
    this.httpClient.get(`${env.apiUrl}/app-instances/${this.instanceId}/invite-codes`).subscribe(
      s => {
        this.inviteCodes.data = s as Array<IInviteCode>;
      },
      e => {
        console.log('ERROR', e);
      }
    )
  }

  public selectClient(client: ClientPreview): void {
    this.router.navigate(['clients', client.id]);
  }

  public openAddInviteCodeDialog(): void {
    const dialogRef = this.dialog.open(AddInviteCodeDialog, {
      data: { instanceId: this.instanceId }
    });
    dialogRef.afterClosed().subscribe(
      res => {
        if (res == true) {
          this.loadInviteCodes();
        }
      }
    )
  }
}

